var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dynamic-gallery-item"},[_c('img',{attrs:{"src":_vm.src,"alt":_vm.sku},on:{"load":_vm.onLoadEnd,"error":_vm.onLoadEnd}})])}
var staticRenderFns = []

export { render, staticRenderFns }